/*
  Bundle builder collection filters: chips that show one collection's products at a time.
  Cards only hide; picked quantities stay in the bundle.
*/
if (!customElements.get('m-bundle-filters')) {
  class MBundleFilters extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('m-bundle-builder') || document;
      this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.apply(button));
      });
    }

    apply(active) {
      const handle = active.dataset.filter;
      this.buttons.forEach((button) => {
        const on = button === active;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.root.querySelectorAll('[data-bundle-card]').forEach((card) => {
        const groups = card.dataset.groups || '';
        card.hidden = handle !== '' && !groups.includes(`|${handle}|`);
      });
    }
  }
  customElements.define('m-bundle-filters', MBundleFilters);
}
